import { Box } from '@mui/material';

type LocationStatusCircleProps = {
  status: boolean;
};

const LocationStatusCircle = ({ status }: LocationStatusCircleProps) => (
  <Box
    width={12}
    height={12}
    borderRadius='50%'
    bgcolor={({ palette }) => (status ? palette.success.main : palette.error.main)}
  />
);

export default LocationStatusCircle;
